import Constants from '../actions/types';

const initialState = {
  records: [],
  loading: false,
  message: null,
  severity: null,
  attributes: {},
  recordId: '',
  links: [],
  updateHistory: [],
  viewRecord: null,
  mutation: false,
  identifier: {
    identifier: '',
    identifierDomainId: -1,
    identifierDomainName: ''
  },
  evaluation: null
};

const adjustRecordHistoryValue = record => {
  const userCreatedBy = record.userCreatedBy;
  const userChangedBy = record.userChangedBy;
  const output = {
    ...record,
    userCreatedBy: userCreatedBy ? userCreatedBy.username : '',
    userChangedBy: userChangedBy ? userChangedBy.username : ''
  };
  return output;
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case Constants.FINDBYATTRIBUTES_REQUEST: {
      const newState = {
        ...state,
        message: null,
        loading: true,
        records: [],
        links: [],
        updateHistory: [],
        viewRecord: null,
        attributes: { ...action.payload },
        mutation: false
      };

      return newState;
    }

    case Constants.FINDBYIDENTIFIER_REQUEST: {
      const newState = {
        ...state,
        message: null,
        loading: true,
        records: [],
        links: [],
        updateHistory: [],
        viewRecord: null,
        identifier: { ...action.payload },
        mutation: false
      };

      return newState;
    }

    case Constants.FINDBYRECORDIDS_REQUEST: {
      const newState = {
        ...state,
        message: null,
        loading: true,
        records: [],
        links: [],
        updateHistory: [],
        viewRecord: null,
        recordId: action.payload,
        mutation: false
      };

      return newState;
    }

    case Constants.FIND_CLEAR_ATTRIBUTES: {
      return {
        ...state,
        attributes: {},
        links: [],
        updateHistory: [],
        viewRecord: null,
        identifier: {
          identifier: '',
          identifierDomainId: -1,
          identifierDomainName: ''
        },
        recordId: ''
      };
    }

    case Constants.FINDBYATTRIBUTES_SUCCESS: {
      const data = action.payload;
      const newState = {
        ...state,
        message: null,
        records: data,
        loading: false,
        mutation: false
      };

      return newState;
    }

    case Constants.FINDBYIDENTIFIER_SUCCESS: {
      const data = action.payload;
      const newState = {
        ...state,
        message: null,
        records: data,
        loading: false,
        mutation: false
      };

      return newState;
    }

    case Constants.FINDBYRECORDIDS_SUCCESS: {
      const newState =
        action.payload.length === 0
          ? {
              ...state,
              loading: false,
              mutation: false,
              records: [],
              message: 'No data was found by this/these record id(s)',
              severity: 'info'
            }
          : {
              ...state,
              message: null,
              records: action.payload,
              loading: false,
              mutation: false
            };

      return newState;
    }

    case Constants.FINDBYATTRIBUTES_FAILURE: {
      const newState = {
        ...state,
        records: [],
        message: action.payload,
        severity: 'error',
        loading: false,
        mutation: false
      };

      return newState;
    }

    case Constants.FINDBYIDENTIFIER_FAILURE: {
      const newState = {
        ...state,
        records: [],
        message: action.payload,
        severity: 'error',
        loading: false,
        mutation: false
      };

      return newState;
    }

    case Constants.FINDBYRECORDIDS_FAILURE: {
      const newState = {
        ...state,
        records: [],
        message: action.payload,
        severity: 'error',
        loading: false,
        mutation: false
      };

      return newState;
    }

    case Constants.RECORD_DELETE_SUCCESS: {
      const record = action.payload;
      const found = state.records.find(r => r.recordId === record.recordId);
      const index = state.records.indexOf(found);
      const newState = {
        ...state,
        records: [
          ...state.records.slice(0, index),
          ...state.records.slice(index + 1)
        ],
        loading: false,
        message: 'Record was deleted successfully.',
        severity: 'info'
      };

      return newState;
    }

    case Constants.RECORD_DELETE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false
      };
      return newState;
    }

    case Constants.RECORD_UPDATE_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        loading: false,
        mutation: true
      };
      return newState;
    }

    case Constants.RECORD_UPDATE_SUCCESS: {
      const record = action.payload;
      const found = state.records.find(r => r.recordId === record.recordId);
      const index = state.records.indexOf(found);
      const newState = {
        ...state,
        records: [
          ...state.records.slice(0, index),
          record,
          ...state.records.slice(index + 1)
        ],
        loading: false,
        message: 'Record was updated successfully.',
        severity: 'info',
        mutation: true
      };
      return newState;
    }

    case Constants.FIND_RECORDLINKS_REQUEST: {
      const newState = {
        ...state,
        links: [],
        loading: true
      };

      return newState;
    }

    case Constants.FIND_RECORDLINKS_SUCCESS: {
      const data = action.payload;
      const newState = {
        ...state,
        message: null,
        links: data,
        loading: false
      };

      return newState;
    }

    case Constants.FIND_RECORDLINKS_FAILURE: {
      const newState = {
        ...state,
        links: [],
        loading: false
      };

      return newState;
    }

    case Constants.FIND_RECORDBYID_SUCCESS: {
      const data = action.payload;
      const newState = {
        ...state,
        message: null,
        viewRecord: data,
        loading: false
      };

      return newState;
    }

    case Constants.FIND_RECORDBYID_FAILURE: {
      const newState = {
        ...state,
        loading: false
      };

      return newState;
    }

    case Constants.LOAD_RECORDHISTORYBYID_SUCCESS: {
      const data = action.payload.map(value => adjustRecordHistoryValue(value));
      const newState = {
        ...state,
        message: null,
        updateHistory: data,
        loading: false
      };

      return newState;
    }

    case Constants.LOAD_RECORDHISTORYBYID_FAILURE: {
      const newState = {
        ...state,
        loading: false
      };

      return newState;
    }

    case Constants.RECORD_LINKS_ADDRECORDLINK_FAILURE: {
      const newState = {
        ...state,
        loading: false,
        message: action.payload,
        severity: 'error'
      };

      return newState;
    }

    case Constants.RECORD_LINKS_ADDRECORDLINK_SUCCESS: {
      const newState = {
        ...state,
        loading: false,
        message: 'The two records were linked together successfully',
        severity: 'info'
      };

      return newState;
    }

    case Constants.RECORD_CLEAR_ERROR: {
      const newState = {
        ...state,
        message: null,
        severity: null
      };
      return newState;
    }

    case Constants.PROBMATCHCONFIG_CLASSIFYPAIR_SUCCESS: {
      const newState = {
        ...state,
        evaluation: action.payload
      };
      return newState;
    }

    case Constants.PROBMATCHCONFIG_CLASSIFYPAIR_FAILURE: {
      const newState = {
        ...state,
        message: action.payload,
        severity: 'error',
        evaluation: null
      };
      return newState;
    }

    case Constants.PROBMATCHCONFIG_CLEAR_EVALUATION: {
      const newState = {
        ...state,
        evaluation: null
      };
      return newState;
    }

    // When the selected entity changes, we need to clear the search fields
    case Constants.ENTITY_SELECT: {
      return {
        ...state,
        attributes: {},
        identifier: {
          identifier: '',
          identifierDomainId: -1,
          identifierDomainName: ''
        },
        records: [],
        links: [],
        viewRecord: null,
        evaluation: null
      };
    }

    default: {
      return state;
    }
  }
};

export default searchReducer;
